import TranslationData from '@/models/TranslationData';

const translation: TranslationData = {
  search: {
    title: 'Keresés',
  },
  searchResults: {
    showMore: 'További eredmények megjelenítése',
    noResults: 'Nincs találat!',
    noResultsHint: '',
    badges: {
      pfsc: '',
      fsc: '',
      fsc_pfsc: 'FSC™/PEFC™',
      ecofriendly: 'Eco',
      overnight: 'Overnight',
      sameday: 'Sameday',
      express: 'Express',
      onlineDesign: 'Online tervezés',
    },
    taglines: {
      home: 'En savoir plus',
      text: 'En savoir plus',
      themes: 'En savoir plus',
      external: 'En savoir plus',
      info: 'En savoir plus',
      category: 'En savoir plus',
      content: 'En savoir plus',
      product: 'Configurez ici',
    },
    headings: {
      categories: 'Catégories de produits',
      products: 'Produits',
      external: 'Autre site',
    },
    slider: {
      previousSlide: 'Show previous content',
      nextSlide: 'Show next content',
    },
  },
  searchInput: {
    inputTooShortError: 'A keresett kifejezés túl rövid (min 2)',
    results: 'Találat',
    result: 'Eredmény',
    youSearchFor: 'Keresett',
    suggestedTerm: {
      didYouMean: 'Erre gondoltad:',
      resultsFor: 'Kattintson ide az összes',
      didYouMeanPostFix: '?',
      resultsForPostFix: 'találatért',
    },
  },
  toolsBar: {
    buttons: {
      listButtonTooltip: 'Lista nézet',
      gridButtonTooltip: 'Csempe nézet',
    },
    quickFilter: {
      filterChips: {
        clearAllFilters: 'Törölje az összes szűrőt',
        resetFilters: '',
      },
      buttonsPanel: {
        filterLabel: 'Szűrők',
        buttonsTooltipLabel: 'Kilátás',
        resultLabel: 'Eredmények',
      },
      contexts:
        {
          product: 'Termék',
          content: 'Vegyes',
          all: 'all',
          category: 'Catégories de produits',
          external: 'Autre site',
        },
    },
    breadcrumbs: {
      start: 'Rajt',
      search: 'Keresés',
    },
  },
  sideBar: {
    filter: 'Szűrő',
    filterOverwrite: {
      category: {
        text: 'Tartalom',
      },
      rootCategory: {
        text: 'Tartalom',
      },
      specialFeatures: {
        text: 'Special Features',
        options: {
          logoFsc: 'FSC',
          logoPfsc: 'PFSC',
          logoFscPfsc: '',
          samedayAvailable: 'Same Day',
          expressAvailable: 'Express',
          overnightAvailable: 'Overnight',
          ecoFriendly: 'Eco Friendly',
          onlineDesign: 'Online tervezés',
          new: 'New',
        },
      },
    },
    more: 'Show more',
    less: 'Show less',
  },
  common: {
    warnings: {
      server401: 'A munkamenete lejárt, és újra be kell jelentkeznie. Azonnal továbbítjuk a bejelentkezéshez.',
      server403: 'A kérelem nem került alkalmazásra, mivel nincsenek érvényes hitelesítési hitelesítő adatok. Kérjük, töltse újra az oldalt, vagy lépjen kapcsolatba ügyfélszolgálatunkkal.',
      default: 'Hiba történt a szerveren. Kérjük, töltse újra az oldalt, vagy lépjen kapcsolatba ügyfélszolgálatunkkal.',
    },
    errors: {
      server400: 'A kérés hibásan alakult. Kérjük, töltse újra az oldalt, vagy lépjen kapcsolatba ügyfélszolgálatunkkal.',
      server404: '404 Page not found. Kérjük, lépjen az előző oldalra, vagy lépjen kapcsolatba ügyfélszolgálatunkkal.',
      server500: 'Hiba történt a szerveren. Kérjük, töltse újra az oldalt, vagy lépjen kapcsolatba ügyfélszolgálatunkkal.',
      server501: 'Hiba történt a szerveren. Kérjük, töltse újra az oldalt, vagy lépjen kapcsolatba ügyfélszolgálatunkkal.',
      server502: 'Hiba történt a szerveren, és érvénytelen választ kap. Kérjük, töltse újra az oldalt, vagy lépjen kapcsolatba ügyfélszolgálatunkkal.',
      server503: 'Hiba történt a szerveren. Kérjük, töltse újra az oldalt, vagy lépjen kapcsolatba ügyfélszolgálatunkkal.',
      server504: 'Hiba történt a szerveren. Kérjük, töltse újra az oldalt, vagy lépjen kapcsolatba ügyfélszolgálatunkkal.',
      default: 'A kiszolgálónak problémája van a kéréssel. Kérjük, töltse újra az oldalt, vagy lépjen kapcsolatba ügyfélszolgálatunkkal.',
    },
  },
};
export default translation;
